<template>
	<v-autocomplete
		class="body-2"
		:label="label"
		hide-details
		:readonly="readonly"
		:items="items"
		:required="required"
		:disabled="disabled"
		:suffix="suffix"
		:prepend-icon="prependIcon"
		:prepend-inner-icon="prependInnerIcon"
		:loading="loading"
		:rules="allRules"
		:solo="solo"
		:filled="filled"
		:flat="flat"
		:outline="outline"
		:name="name"
		:value="value"
		v-on="aOn"
		@input="onInput"
		@change="onChange">
	</v-autocomplete>
</template>

<script>
	// import {toNum, toStr} from '../../js/common'

	export default {
		props: {
			label: String,
			items: Array,
			value: [String, Number],
			readonly: Boolean,
			disabled: Boolean,
			required: Boolean,
			loading: Boolean,
			solo: Boolean,
			filled: Boolean,
			outline: Boolean,
			flat: Boolean,
			suffix: String,
			prependIcon: String,
			prependInnerIcon: String,
			name: String,
			align: String,
			rules: Array,
			aOn: Object,
		},
		computed: {
			allRules() {
				const rules = this.rules || []

				if (this.required) {
					var rule =
						v => !!v || 'Введите значение'

					rules.push(rule)
				}

				// console.log(rules)

				return rules
			},
		},
		data: () => ({
		}),
		methods: {
			onInput: function (val) {
				// console.log('onInput')
				// console.log('val', val)
				this.$emit('input', val)
			},
			onChange: function(e) {
				// console.log('onChange')
				// e = this.format(e)
				this.$emit('input', e)
				this.$emit('change', e)
			},
		}
	}
</script>

<style scoped>
	.v-autocomplete {
		padding-top: 0px;
		margin-top: 0px;
	}
	/deep/ .v-input__slot {
		margin-bottom: 0px;
	}
	/deep/ .v-select__slot > input {
		text-align: center;
		padding-bottom: 4px;
	}
</style>
